import { IRefIds } from 'constants/refs';
import { post } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IMemorySemanticUnifierConfig } from '../modules/Memory/components/MemorySemanticUnifierConfig';

export type IMemorySemanticUnifierMember = {
  id?: number;
  pattern: string;
  count: number;
  items?: Array<{ translation_id: number; course_id: number }>;
};

export type IMemorySemanticUnifierRow = {
  id: number; // local row id for grid
  group_id: string;
  representative_pattern: string;
  size: number;
  members: IMemorySemanticUnifierMember[];
};

export default class MemorySemanticUnifierModel extends BaseModel<IMemorySemanticUnifierRow> {
  constructor(options: IModelOptions) {
    super(options);
    this.ref = IRefIds.memorySemanticUnifier;
    this.gridName = 'MemorySemanticUnifier';
    this.getGridColumns();
  }

  // Reset the grid state and optionally set loading
  reset(loading = false) {
    this.loadingGrid = !!loading;
    this.gridData = [] as any;
    this.gridDataUpdateRow = { type: 'none', data: null } as any;
    this.render();
  }

  async change(item: { pattern: string }) {
    const glossary = String(item?.pattern || '').trim();
    if (!glossary) return { data: null };
    return await post<any>(`memory-semantic-unifier/change`, { glossary });
  }

  async requestBuild(config: IMemorySemanticUnifierConfig) {
    const payload: any = {
      ...config,
      dialect_id: config.general.source_dialect,
      threshold: config.general.threshold ?? 0.82,
      topK: config.general.topK ?? 50,
    };
    this.loadingGrid = true;
    this.render();
    const resp = await post<any>(`memory-semantic-unifier/groups/build`, payload);
    this.loadingGrid = false;
    return resp?.data;
  }
}
